import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import './ProjectDetail.css';

function ProjectDetail() {
  const { slug } = useParams();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`/api/public/projects.php?slug=${slug}`)
      .then(res => res.json())
      .then(data => {
        if (data.success) setProject(data.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <>
        <Header />
        <div className="project-detail-loading">
          <div className="container">Loading project details...</div>
        </div>
        <Footer />
      </>
    );
  }

  if (!project) {
    return (
      <>
        <Header />
        <div className="project-detail-notfound">
          <div className="container">
            <h1>Project Not Found</h1>
            <p>The project you're looking for doesn't exist.</p>
            <a href="/projects" className="btn-primary">View All Projects</a>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="project-detail">
        <div className="container">
          {/* Back Button */}
          <div className="project-detail-back">
            <a href="/projects">← Back to Projects</a>
          </div>

          {/* Hero Section */}
          <div className="project-detail-hero">
            {project.cover_image ? (
              <img src={project.cover_image} alt={project.title} className="project-detail-cover" />
            ) : (
              <div className="project-detail-cover-placeholder">No Cover Image</div>
            )}
            <div className="project-detail-hero-content">
              <span className="project-detail-category">{project.category}</span>
              <h1 className="project-detail-title">{project.title}</h1>
              <p className="project-detail-location">{project.location}</p>
            </div>
          </div>

          {/* Content */}
          <div className="project-detail-body">
            <div className="project-detail-info">
              <h3>About This Project</h3>
              <p>{project.description || 'No description available.'}</p>
            </div>

            {project.client_name && (
              <div className="project-detail-meta">
                <h4>Client</h4>
                <p>{project.client_name}</p>
              </div>
            )}

            {project.completion_date && (
              <div className="project-detail-meta">
                <h4>Completion Date</h4>
                <p>{new Date(project.completion_date).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}</p>
              </div>
            )}

            {/* Gallery Images */}
            {project.images && project.images.length > 0 && (
              <div className="project-detail-gallery">
                <h3>Project Gallery</h3>
                <div className="project-detail-gallery-grid">
                  {project.images.map((img, index) => (
                    <img key={index} src={img.image_url} alt={img.caption || project.title} />
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ProjectDetail;
